module.exports = __webpack_public_path__ + "img/header_bg3.751d0356.png";